let initialState = {
	apiStatus: {},
	apiResponse: {},
	accountBooks: [],
	salesPersons: [],
	vouchers: [],
	branches: [],
	selectedBranch: null,
	currentPage: '1',
	currentPageTitle: 'Dashboard',
	states: [],
	users: [],
	classes: [],
	assets: [],
	vehicles: [],
	vendors: [],
	batches: [],
	activeBatch: null,
	partNumbers: [],
	credentials: [],
};

const globalReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'LOGOUT': {
			return initialState;
		}
		case 'SET_API_STATUS':
			return {
				...state,
				apiStatus: {
					...state.apiStatus,
					...action.payload,
				},
			};
		case 'SET_API_RESPONSE':
			return {
				...state,
				apiResponse: {
					...state.apiResponse,
					...action.payload,
				},
			};
		case 'SET_BRANCHES':
			return {
				...state,
				branches: action.payload,
			};
		case 'SET_CURRENT_PAGE':
			return {
				...state,
				currentPage: action.payload.currentPage,
				currentPageTitle: action.payload.currentPageTitle,
			};
		case 'SET_SELECTED_BRANCH':
			return {
				...state,
				selectedBranch: action.payload,
			};
		case 'SET_ACCOUNT_BOOKS':
			return {
				...state,
				accountBooks: action.payload,
			};
		case 'SET_SALES_PERSONS':
			return {
				...state,
				salesPersons: action.payload,
			};
		case 'SET_STATES':
			return {
				...state,
				states: action.payload,
			};
		case 'SET_USERS':
			return {
				...state,
				users: action.payload,
			};
		case 'SET_CLASSES':
			return {
				...state,
				classes: action.payload,
			};
		case 'SET_VOUCHERS_HEAD':
			return {
				...state,
				vouchers: action.payload,
			};
		case 'SET_ASSETS':
			return {
				...state,
				assets: action.payload,
			};
		case 'SET_VEHICLES':
			return {
				...state,
				vehicles: action.payload,
			};
		case 'SET_VENDORS':
			return {
				...state,
				vendors: action.payload,
			};
		case 'SET_CREDENTIALS':
			return {
				...state,
				credentials: action.payload,
			};
		case 'SET_PART_NUMBERS':
			return {
				...state,
				partNumbers: action.payload,
			};
		case 'SET_BATCHES':
			return {
				...state,
				batches: action.payload,
				activeBatch: action.payload.find((batch) => batch.isActive)?._id,
			};
		default:
			return state;
	}
};

export { globalReducer };
